import React, { Component } from 'react';
import { Button, Card, Col, DatePicker, Form, Input, Row, Select } from 'antd';
import moment from 'moment';
import { queryDeleteAttachment } from '@api/pub/attachment';
import UploadFile from '@comm/upload/UploadFile';
import { connect } from 'react-redux';
import { BackBtn } from '@comm/BackBtn';

const { Option } = Select;
const FormItem = Form.Item;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // type:'1',
      type: this.props.data.type,
      legalCodeFile: [],
      licenseFile: [],
      delFiles: [],
    };
  }

  componentWillMount() {}

  componentWillReceiveProps(nextProps) {
    if (nextProps.data.type !== this.props.data.type) {
      this.setState({
        type: `${nextProps.data.type}`,
      });
    }
  }

  formatFile = fileList => {
    const file = [];
    fileList.map(item => {
      const fileItem = {};
      fileItem.uuid = item.uuid;
      fileItem.url = item.url;
      fileItem.size = item.size;
      fileItem.name = item.name;
      fileItem.suffix = item.name.split('.')[1];
      file.push(fileItem);
      return file;
    });
    return file;
  };

  fixFileArr = file => {
    const fileArr = [];
    const fileItem = {};
    if (file) {
      fileItem.uid = file.uuid;
      fileItem.name = file.name;
      fileItem.status = 'done';
      fileItem.url = file.url;
      fileArr.push(fileItem);
    }
    return fileArr;
  };

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { saveBase } = this.props;
    const custom = this.props.form.getFieldsValue();
    const { legalCodeFile, licenseFile } = this.state;
    if (legalCodeFile.length) {
      custom.legalCodeFile = this.formatFile(legalCodeFile)[0];
      custom.legalCodeFileUuid = custom.legalCodeFile.uuid;
    }
    if (licenseFile.length) {
      custom.licenseFile = this.formatFile(licenseFile)[0];
      custom.licenseFileUuid = custom.licenseFile.uuid;
    }
    custom.date = custom.date ? custom.date._d.getTime() : '';
    this.props.form.validateFields(err => {
      if (!err) {
        saveBase(custom);
        if (this.state.delFiles.length > 0) {
          this.state.delFiles.map(item => {
            queryDeleteAttachment({
              uuid: item.uuid,
            }).then(() => {});
            return item;
          });
        }
      }
    });
  };

  /**
   *文件删除
   */
  fileRemove = file => {
    const { delFiles } = this.state;
    delFiles.push(file);
    this.setState({ delFiles });
  };

  handlelicenseFile = fileList => {
    this.setState({
      licenseFile: fileList,
    });
  };

  handlelegalCodeFile = fileList => {
    this.setState({
      legalCodeFile: fileList,
    });
  };

  changePage = () => {
    this.props.changePage(2);
  };

  handleClick = () => {};

  handleChange = value => {
    this.setState({
      type: value,
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data } = this.props;
    const typedata = data.typedata || {};
    const legalCodeFile = this.fixFileArr(data.legalCodeFile);
    const licenseFile = this.fixFileArr(data.licenseFile);
    if (data.type === 0) {
      data.type = '0';
    }
    const ItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 12 },
    };

    return (
      <Form onSubmit={this.submit}>
        <div style={{ marginBottom: 15, marginTop: '-45px' }}>
          <BackBtn />
        </div>
        <Card title="基本信息">
          <Row>
            <Col span={10}>
              <FormItem label="客户类型" {...ItemLayout}>
                {getFieldDecorator('type', {
                  rules: [{ required: true, message: '请选择客户类型!' }],
                  initialValue: `${typedata.type}`,
                })(
                  <Select size="large" onChange={this.handleChange}>
                    <Option key="1" value="1">
                      公司
                    </Option>
                    <Option key="0" value="0">
                      个人
                    </Option>
                  </Select>,
                )}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="客户名称" {...ItemLayout}>
                {getFieldDecorator('name', {
                  rules: [{ required: true, message: '客户名称!' }],
                  initialValue: data.name,
                })(<Input placeholder="客户名称" />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="联系人" {...ItemLayout}>
                {getFieldDecorator('contactsName', {
                  rules: [{ required: true, message: '请输入联系人姓名!' }],
                  initialValue: data.contactsName,
                })(<Input placeholder="联系人" />)}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="职位" {...ItemLayout}>
                {getFieldDecorator('contactsPost', {
                  initialValue: data.contactsPost,
                })(<Input placeholder="职位" />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="联系方式" {...ItemLayout}>
                {getFieldDecorator('contactsPhone', {
                  rules: [{ required: true, message: '请输入联系人电话!' }],
                  initialValue: data.contactsPhone,
                })(<Input placeholder="联系方式" />)}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="微信" {...ItemLayout}>
                {getFieldDecorator('contactsWx', {
                  initialValue: data.contactsWx,
                })(<Input placeholder="微信" />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="邮箱" {...ItemLayout}>
                {getFieldDecorator('contactsEmail', {
                  initialValue: data.contactsEmail,
                })(<Input placeholder="邮箱" />)}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="通信地址" {...ItemLayout}>
                {getFieldDecorator('contactsAddr', {
                  initialValue: data.contactsAddr,
                })(<Input placeholder="通信地址" />)}
              </FormItem>
            </Col>
          </Row>
        </Card>
        {this.state.type !== '0' ? (
          <Card title="公司信息">
            <Row>
              <Col span={10}>
                <FormItem label="公司名称" {...ItemLayout}>
                  {getFieldDecorator('organizationName', {
                    rules: [{ required: true, message: '请输入公司名称!' }],
                    initialValue: data.organizationName || '帮实',
                  })(<Input placeholder="公司名称" />)}
                </FormItem>
              </Col>
              <Col span={10}>
                <FormItem label="统一社会信用代码" {...ItemLayout}>
                  {getFieldDecorator('organizingCode', {
                    rules: [{ required: true, message: '请输入统一社会信用代码!' }],
                    initialValue: data.organizingCode,
                  })(<Input placeholder="统一社会信用代码" />)}
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span={10}>
                <FormItem label="注册地址" {...ItemLayout}>
                  {getFieldDecorator('registerAddress', {
                    rules: [{ required: true, message: '请输入注册地址!' }],
                    initialValue: data.registerAddress,
                  })(<Input placeholder="注册地址" />)}
                </FormItem>
              </Col>
              <Col span={10}>
                <FormItem label="成立时间" {...ItemLayout}>
                  {getFieldDecorator('date', {
                    initialValue: data.date ? moment(data.date) : null,
                  })(<DatePicker style={{ width: '100%' }} />)}
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span={10}>
                <FormItem label="营业执照上传" {...ItemLayout}>
                  <UploadFile
                    type="ghost"
                    handleUpload={this.handlelicenseFile}
                    fileList={licenseFile}
                    onRemove={this.fileRemove}
                  />
                </FormItem>
              </Col>
              <Col span={10}>
                <FormItem label="公司规模" {...ItemLayout}>
                  {getFieldDecorator('scale', {
                    initialValue: data.scale,
                  })(<Input placeholder="公司规模" />)}
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span={10}>
                <FormItem label="公司官网" {...ItemLayout}>
                  {getFieldDecorator('website', {
                    rules: [{ required: true, message: '请输入公司官网!' }],
                    initialValue: data.website,
                  })(<Input placeholder="公司官网" />)}
                </FormItem>
              </Col>
            </Row>
          </Card>
        ) : (
          ''
        )}
        {this.state.type !== '0' ? (
          <Card title="法人信息">
            <Row>
              <Col span={10}>
                <FormItem label="姓名" {...ItemLayout}>
                  {getFieldDecorator('legalName', {
                    initialValue: data.legalName,
                  })(<Input placeholder="姓名" />)}
                </FormItem>
              </Col>
              <Col span={10}>
                <FormItem label="身份证号" {...ItemLayout}>
                  {getFieldDecorator('legalCode', {
                    initialValue: data.legalCode,
                  })(<Input placeholder="身份证号" />)}
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span={10}>
                <FormItem label="联系方式" {...ItemLayout}>
                  {getFieldDecorator('legalPhone', {
                    initialValue: data.legalPhone,
                  })(<Input placeholder="联系方式" />)}
                </FormItem>
              </Col>
              <Col span={10}>
                <FormItem label="身份证上传" {...ItemLayout}>
                  <UploadFile
                    type="ghost"
                    handleUpload={this.handlelegalCodeFile}
                    fileList={legalCodeFile}
                    onRemove={this.fileRemove}
                  />
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span={10}>
                <FormItem label="微信号" {...ItemLayout}>
                  {getFieldDecorator('legalWx', {
                    initialValue: data.legalWx,
                  })(<Input placeholder="微信号" />)}
                </FormItem>
              </Col>
              <Col span={10}>
                <FormItem label="邮箱" {...ItemLayout}>
                  {getFieldDecorator('legalEmail', {
                    initialValue: data.legalEmail,
                  })(<Input placeholder="邮箱" />)}
                </FormItem>
              </Col>
            </Row>
          </Card>
        ) : (
          ''
        )}
        <Card title="其他">
          <Row>
            <Col span={10}>
              <FormItem label="知识产权情况" {...ItemLayout}>
                {getFieldDecorator('intellectual', {
                  initialValue: data.intellectual,
                })(<Input placeholder="知识产权情况" />)}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="科技项目申请情况" {...ItemLayout}>
                {getFieldDecorator('technology', {
                  initialValue: data.technology,
                })(<Input placeholder="科技项目申请情况" />)}
              </FormItem>
            </Col>
          </Row>
        </Card>
        <div style={{ marginBottom: 15 }}>
          <Button icon="save" style={{ marginRight: 10 }} type="primary" htmlType="submit">
            下一步
          </Button>
          <Button icon="save" style={{ marginRight: 10 }} htmlType="submit">
            暂存
          </Button>
        </div>
      </Form>
    );
  }
}

export default connect(state => ({ organization: state.organization }))(
  Form.create({ wrappedComponentRef: true })(BaseForm),
);



// WEBPACK FOOTER //
// ./src/components/custom/base/FormEdit.js